import { ENCODING_VALIDATION_MESSAGE } from '@assetManagement/data/uploadVideoValidationMessage';
import {
  isValidEncodedAudio,
  isValidEncodedVideo,
} from './validateMediaEncoding';
import createErrorHandler from 'utils/createErrorHandler';
import isValidVideoBitrate from './isValidVideoBitrate';
import isValidVideoSize from './isValidVideoSize';
import isValidVideoFPS from './isValidVideoFPS';

async function validateVideo(file, config) {
  const [errors, addError] = createErrorHandler();

  const {
    allowedVideoType,
    maxFileSize,
    maxBitrateSize,
    maxFPS,
    audioCodec,
    videoCodec,
  } = config;

  const errorKey = 'uploadVideo';

  if (file?.type?.indexOf(allowedVideoType) !== 0) {
    addError(errorKey, `Please select only mp4 videos`);
    return errors;
  }

  if (maxFileSize && !isValidVideoSize(file, maxFileSize)) {
    addError(
      errorKey,
      `Video should be less than ${maxFileSize / 1_000_000} MB`
    );
  }

  const isValidBitrate = await isValidVideoBitrate(file, maxBitrateSize);
  if (!isValidBitrate) {
    addError(
      errorKey,
      `Maximum allowed bitrate is ${maxBitrateSize} kbps. Please choose a lower bitrate`
    );
  }

  const isValidFPS = await isValidVideoFPS(file, maxFPS);
  if (!isValidFPS) {
    addError(errorKey, `Maximum allowed Frame Per Second is ${maxFPS}`);
  }

  const videoEncodedMsg = await isValidEncodedVideo(file, videoCodec);
  if (!videoEncodedMsg.includes(ENCODING_VALIDATION_MESSAGE.encoded)) {
    addError(errorKey, videoEncodedMsg);
  }

  const audioEncodedMsg = await isValidEncodedAudio(file, audioCodec);
  if (audioEncodedMsg.includes(ENCODING_VALIDATION_MESSAGE.invalidAudioCodec)) {
    addError(errorKey, audioEncodedMsg);
  }

  return errors;
}

export default validateVideo;
